import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { mou } from '../../components/apipath';
import SwitchBox from "../../components/switchBox";
import {switchHelper} from "../../modules/helpers";

function AdmMou() {
    const [moulist, setMoulist] = useState([]);
    const [editingMou, setEditingMou] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [newMou, setNewMou] = useState(null); // 用於保存新行的數據
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { token } = useAuth();
    //Read 將後端mou所有合作夥伴資訊導入
    const fetchData = async () => {
        try {
            setLoading(true); // 開始加載
            const response = await axios.get(`${mou}`, {headers:{token: token}});
            setMoulist(response.data.data);
            setLoading(false); // 完成加載
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    //Update 設定編輯狀態
    const startEditing = (mou) => {
        setEditingMou(mou);
        setUpdatedData(mou);
    };
    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setUpdatedData({
                mou_id: editingMou.mou_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                mou_id: editingMou.mou_id,
                ...updatedData,
                [name]: value,
            });
        }
    };
    //Update 將資訊依照mou_id回傳給後端
    const saveChanges = async () => {
        try {
            await axios.put(`${mou}`, updatedData, {headers: {
                token: token,
                Authorization: `Bearer ${token}`
            }});
            // 更新前端的 moulist 狀態
            const updatedMouList = moulist.map(mou => {
                if (mou.mou_id === editingMou.mou_id) {
                    return updatedData;
                }
                return mou;
            });
            setMoulist(updatedMouList);
            setEditingMou(null);
        } catch (error) {
            console.error('Error updating mou:', error);
        }
    };

    // Create 點擊新增按鈕時的處理函數
    const handleAddNew = () => {
        setNewMou({
            name: '',
            discount: '',
            memo: '',
            status: 1,
            code: '',
        });
    };


    // Create 處理新行輸入的變化
    const handleNewInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setNewMou({
                ...newMou,
                [name]: switchHelper(checked),
            });
        } else {
            setNewMou({
                ...newMou,
                [name]: value,
            });
        }
    };


    // Create 保存新行
    const handleSaveNew = async () => {
        try {
            // 發送 POST 請求將新合作夥伴數據保存到後端
            const response = await axios.post(`${mou}`, newMou, {headers: {
                token: token,
                Authorization: `Bearer ${token}`
            }});
            if (response.data.status === 200){
                // 新增成功，顯示成功通知
                alert('新增成功！');
                // 將新的合作夥伴數據添加到 moulist 狀態中
                let newData = newMou;
                newData.mou_id = response.data.data[1][0].insertId;
                setMoulist([...moulist, newData]);
                // 重置 newMou 狀態
                setNewMou(null);
                // 跳轉到另一個頁面（例如合作夥伴列表頁）
                //navigate('/adm/admmou'); // 請根據您的路由結構指定正確的路徑
            } else {
                console.error('Error saving new mou:', response.data.msg);
            }
            
        } catch (error) {
            console.error('Error saving new mou:', error);
        }
    };
    return (
        <>
        <div className="container mt100">
            <div className="text-end mt-2">
                <button className="btn btn-success me-2" onClick={handleAddNew}>新增</button>
            </div>
            <div className="mt-2 table-responsive">
            <table className="table table-striped border table-hover">
                <thead>
                    <tr>
                        <th scope="col">姓名</th>
                        <th scope="col">折扣</th>
                        <th scope="col">狀態</th>
                        <th scope="col">優惠碼</th>
                        <th scope="col">備註</th>
                        <th scope="col">修改</th>
                    </tr>
                </thead>
                <tbody>
                    {/* 渲染新行 */}
                    {newMou && (
                    <tr>
                        <td>
                            <input
                                className="border border-primary form-control form-control-sm"
                                type="text"
                                name="name"
                                value={newMou.name}
                                onChange={handleNewInputChange}
                                required // 必填
                            />
                        </td>
                        <td>
                            <input
                                className="border border-primary form-control form-control-sm"
                                type="number"
                                name="discount"
                                value={newMou.discount}
                                onChange={handleNewInputChange}
                                required // 必填
                            />
                        </td>
                        <td>
                            {SwitchBox('status', newMou.status, handleNewInputChange)}
                        </td>
                        <td>
                            <input
                                className="border border-primary form-control form-control-sm"
                                type="textarea"
                                name="code"
                                value={newMou.code}
                                onChange={handleNewInputChange}
                            />
                        </td>
                        <td>
                            <input
                                className="border border-primary form-control form-control-sm"
                                type="textarea"
                                name="memo"
                                value={newMou.memo}
                                onChange={handleNewInputChange}
                            />
                        </td>
                        <td>
                            {/* 保存和取消按鈕 */}
                            <button
                                className="btn btn-primary m-1"
                                onClick={handleSaveNew}
                            >
                                保存
                            </button>
                            <button
                                className="btn btn-secondary m-1"
                                onClick={() => setNewMou(null)}
                            >
                                取消
                            </button>
                        </td>
                    </tr>
                )}
                {moulist.map((mou) => (
                    <tr key={mou.mou_id}>
                        <td>
                            {editingMou && editingMou.mou_id === mou.mou_id ? (
                                <input
                                    className="border border-primary form-control form-control-sm"
                                    type="text"
                                    name="name"
                                    value={updatedData.name}
                                    onChange={handleInputChange}
                                />
                            ) : (
                                mou.name
                            )}
                        </td>
                        <td>
                            {editingMou && editingMou.mou_id === mou.mou_id ? (
                                <input
                                    className="border border-primary form-control form-control-sm"
                                    type="number"
                                    name="discount"
                                    value={updatedData.discount}
                                    onChange={handleInputChange}
                                />
                            ) : (
                                mou.discount
                            )}
                        </td>
                        <td>
                            {editingMou && editingMou.mou_id === mou.mou_id ? (
                                <input
                                    className="border border-primary form-control form-control-sm"
                                    type="number"
                                    name="code"
                                    value={updatedData.code}
                                    onChange={handleInputChange}
                                />
                            ) : (
                                mou.discount
                            )}
                        </td>
                        <td>
                            {editingMou && editingMou.mou_id === mou.mou_id ? (
                                SwitchBox('status', updatedData.status, handleInputChange)
                            ) : (
                                mou.status === 1 ? "啟用" : "關閉" 
                            )}
                        </td>
                        <td>
                            {editingMou && editingMou.mou_id === mou.mou_id ? (
                                <input
                                    className="border border-primary form-control form-control-sm"
                                    type="textarea"
                                    name="memo"
                                    value={updatedData.memo}
                                    onChange={handleInputChange}
                                />
                            ) : (
                                mou.memo
                            )}
                        </td>
                        <td>
                            {editingMou && editingMou.mou_id === mou.mou_id ? (
                                <>
                                    <button
                                        className="btn btn-primary m-1"
                                        onClick={saveChanges}
                                    >
                                        保存
                                    </button>
                                    <button
                                        className="btn btn-secondary m-1"
                                        onClick={() => setEditingMou(null)}
                                    >
                                        取消
                                    </button>
                                </>
                            ) : (
                                <button
                                    className="btn btn-primary m-1"
                                    onClick={() => startEditing(mou)}
                                >
                                    編輯
                                </button>
                            )}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
        </div>
            
        </>
    );
}
export default AdmMou;